/* global self */
import { default as cssBlankPseudo } from './browser';
self.cssBlankPseudo = cssBlankPseudo;
